import { Form, Select } from 'antd';
import { useGetManyTransports } from 'api/transports/use-get-many-transports';
import type { ICargoFiltersDeliveryTruckInputProps } from './types';

export const CargoFiltersDeliveryTruckInput = (props: ICargoFiltersDeliveryTruckInputProps) => {
  const { name, disabled = false, className, handleSuccess } = props;

  const { data: trucks } = useGetManyTransports({ limit: 100, filters: { type: 'truck' }, isSkip: disabled });

  const truckOptions = (trucks?.data || []).map((truck) => ({
    value: truck.id,
    label: truck.plateNumber,
  }));

  return (
    <Form.Item name={name} className={className}>
      <Select
        placeholder='Delivery truck'
        optionFilterProp='label'
        options={truckOptions}
        disabled={disabled}
        showSearch
        allowClear
        onChange={handleSuccess}
      />
    </Form.Item>
  );
};
